var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser03Solid = function SvgUser03Solid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2024",
    fillRule: "evenodd",
    d: "M1.515 12.876C3.185 11.104 5.47 10 8 10s4.815 1.104 6.485 2.876A.667.667 0 0 1 14 14H2a.667.667 0 0 1-.485-1.124M4.333 5a3.667 3.667 0 1 1 7.334 0 3.667 3.667 0 0 1-7.334 0",
    clipRule: "evenodd"
  })));
};
export default SvgUser03Solid;